<script>
	import { getContext } from 'svelte'
	import { styles } from '../scripts/styles.js'
	import { createEventDispatcher } from 'svelte'
	import { tweened } from 'svelte/motion'
	import { bounceOut } from 'svelte/easing'
	import IntersectionObserver from 'svelte-intersection-observer'

	const globals = getContext('globals')
	export let buttonColor = 'hsl(0,0%,100%)'
	export let buttonBg = 'transparent'
	export let buttonBgHover = 'transparent'
	export let buttonHover = 'transparent'
	export let inputBorder = 'hsl(72,100%,50%)'
	export let shadow = globals.shadow
	export let fsS = globals.fsS
	export let margin = '0px 0px 0px 0px'
	export let padding = '0% 2% 0% 2%'
	export let title = 'button'
	export let borderRadius = '10px'

	const dispatch = createEventDispatcher()

	let element

	let tweenedAngle = 90

	const button_action = () => {
		dispatch('send', { name: 'button' })
	}

	const angle = tweened(tweenedAngle, {
		duration: 600,
		delay: 200,
		easing: bounceOut,
	})
</script>

<IntersectionObserver
	{element}
	on:observe={(e) => {
		if (e.detail.isIntersecting) {
			angle.set(0)
		} else {
			angle.set(90)
		}
	}}
>
	<button
		on:click
		bind:this={element}
		use:styles={{
			fsS,
			inputBorder,
			buttonColor,
			buttonBg,
			buttonHover,
			buttonBgHover,
			shadow,
			margin,
			padding,
			borderRadius,
		}}
		style="transform:rotateY({$angle}deg)">{title}</button
	>
</IntersectionObserver>

<style>
	button {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: var(--fsS);
		background: var(--buttonBg);
		border: 1px solid var(--inputBorder);
		border-radius: var(--borderRadius);
		color: var(--buttonColor);
		cursor: pointer;
		box-shadow: 3px 3px 3px var(--shadow);
		padding: var(--padding);
		margin: var(--margin);
		outline: none;
	}

	button:hover {
		background: var(--buttonBgHover);
	}
</style>
